export default __webpack_public_path__ + "locales/ko-KR/SingleSignOn.json?hash=8099f1ac482b3d659daff800614bc082";